import { dgStackingRulesApi, ImoClassStackingRuleDto, UpdateDGStackingRuleDto } from '@yard/app/api/dg-config-api'
import { computed, makeObservable, observable, runInAction } from 'mobx'

export class DGStackingRuleStore {
  data = new Map<string, ImoClassStackingRuleDto>()

  constructor() {
    makeObservable(this, {
      data: observable,
      entries: computed,
    })
  }

  get entries(): ImoClassStackingRuleDto[] {
    return Array.from(this.data.values())
  }

  getById(id: string): ImoClassStackingRuleDto | undefined {
    return this.data.get(id)
  }

  private setAll(entities: ImoClassStackingRuleDto[]): void {
    runInAction(() => {
      this.data = new Map(entities.map(item => [item.id, item]))
    })
  }

  async loadAll(): Promise<void> {
    const rules = await dgStackingRulesApi.getAll()
    this.setAll(rules)
  }

  async update(id: string, dto: UpdateDGStackingRuleDto): Promise<void> {
    await dgStackingRulesApi.update(id, dto)
  }

  async resetToDefaults(): Promise<void> {
    const rules = await dgStackingRulesApi.resetToDefaults()
    this.setAll(rules)
  }
}
